import type { StaffDirectoryAttachment } from "@/core/authUser/entities/StaffDirectoryAttachment";

/** Bloc `staffDirectory` de GET /admin/users/me. */
export interface StaffDirectoryDto {
  enrolled?: boolean | null;
  email?: string | null;
  branchCode?: string | null;
  branchLabel?: string | null;
  branchCount?: number | null;
}

export interface CurrentUserDto {
  login?: string | null;
  email?: string | null;
  branch?: string | null;
  staffDirectory?: StaffDirectoryDto | null;
}

/**
 * Rend `null` quand le bloc est absent : un back anterieur ne le renvoie pas, et fabriquer un
 * rattachement vide ferait passer un agent correctement inscrit pour un agent sans agence.
 */
export const mapStaffDirectoryDtoToEntity = (
  dto: CurrentUserDto | null | undefined,
): StaffDirectoryAttachment | null => {
  const staffDirectory = dto?.staffDirectory;
  if (!staffDirectory) {
    return null;
  }

  return {
    enrolled: staffDirectory.enrolled === true,
    email: normalizeText(staffDirectory.email),
    branchCode: normalizeText(staffDirectory.branchCode),
    branchLabel: normalizeText(staffDirectory.branchLabel),
    branchCount:
      typeof staffDirectory.branchCount === "number" &&
      Number.isFinite(staffDirectory.branchCount)
        ? staffDirectory.branchCount
        : 0,
  };
};

// Une chaine vide se lit comme une valeur renseignee a l'affichage : on la ramene a l'absence.
const normalizeText = (value: string | null | undefined): string | null => {
  const trimmed = typeof value === "string" ? value.trim() : "";
  return trimmed.length > 0 ? trimmed : null;
};
